import * as React from 'react'
import { WidgetSpinner } from '../../common/Spinner/Spinner'

type DashboardWidgetLoadingProps = React.PropsWithChildren & {
    something?: string
}

export const DashboardWidgetLoading: React.FC<
    DashboardWidgetLoadingProps
> = () => {
    return (
        <div className="flex items-center justify-center rounded-xl border border-neutral-200 bg-neutral-50 p-4">
            <WidgetSpinner />
        </div>
    )
}
